<div fxLayout="column" id="footer" class="m-b-20">
  <mat-divider fxFlexAlign="center" class="divider"></mat-divider>
</div>
